import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExerciseCounterComponent } from './exercise-counter.component';


@NgModule({
  imports: [
    CommonModule
  ],
  exports: [ExerciseCounterComponent],
  declarations: [ExerciseCounterComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ExerciseCounterComponentModule {}
